<template>
  <form @submit.prevent="handleUpload()">
    <div class="form-group">
      <label for="invoice-file">{{ $t("LABELS.UPLOAD_FILES") }}</label>
      <input
        type="file"
        id="invoice-file"
        class="form-control"
        @change="onFileChange"
        :disabled="isLoading"
        multiple
        required
      />
      <small v-if="files.length > 0" class="form-text text-muted mt-2">
        {{ files.length }} {{ $t("LABELS.FILES_SELECTED") }}
      </small>
    </div>

    <v-alert v-if="duplicateError" type="warning" class="mt-3">
      <div v-for="(msg, idx) in duplicateError" :key="idx">{{ msg }}</div>
      <div class="mt-3">
        <button
          type="button"
          class="btn btn-warning"
          @click="handleUploadWithMakeUnique"
          :disabled="isLoading"
        >
          <i class="fa fa-check"></i>
          {{ $t("LABELS.PROCEED_ANYWAY") }}
        </button>
      </div>
    </v-alert>

    <v-alert v-if="error" type="error" class="mt-3">
      <div v-for="(msg, idx) in error" :key="idx">{{ msg }}</div>
    </v-alert>

    <v-alert v-if="success" type="success" class="mt-3">
      {{ success }}
    </v-alert>

    <v-alert v-if="processingMessage" type="info" class="mt-3">
      {{ processingMessage }}
    </v-alert>

    <button
      type="submit"
      class="btn btn-success mt-3"
      :disabled="files.length === 0 || isLoading"
    >
      <span v-if="isLoading">
        <i class="fa fa-spinner fa-spin"></i>
        {{ $t("LABELS.UPLOADING") }}
      </span>
      <span v-else>
        <i class="fa fa-upload"></i>
        {{ $t("LABELS.UPLOAD") }}
      </span>
    </button>
  </form>
</template>

<script>
import { UPLOAD_AI_INVOICE_FILE } from "@/modules/ai-invoices/store/ai-invoices.module";
import { mapGetters } from "vuex";

export default {
  name: "AiInvoiceUploadForm",
  data() {
    return {
      files: [],
      isLoading: false,
      error: "",
      duplicateError: "",
      success: "",
      processingMessage: ""
    };
  },
  computed: {
    ...mapGetters(["isLoadingAiInvoice"])
  },
  methods: {
    onFileChange(e) {
      this.files = Array.from(e.target.files);
      this.error = "";
      this.duplicateError = "";
      this.success = "";
      this.processingMessage = "";
    },
    handleUpload(makeUnique = false) {
      if (this.files.length === 0) return;

      this.isLoading = true;
      this.error = "";
      this.duplicateError = "";
      this.success = "";
      this.processingMessage = "";

      const formData = new FormData();
      this.files.forEach(file => {
        formData.append("files[]", file);
      });

      if (makeUnique) {
        formData.append("makeUnique", "1");
      }

      this.$store
        .dispatch(UPLOAD_AI_INVOICE_FILE, formData)
        .then(() => {
          const fileCount = this.files.length;
          this.success = this.$t("LABELS.UPLOAD_SUCCESS_MULTIPLE", {
            count: fileCount
          });

          if (fileCount > 1) {
            this.processingMessage = this.$t("LABELS.INVOICES_PROCESSING_INFO");
          }

          this.files = [];
          document.getElementById("invoice-file").value = "";

          this.$emit("uploaded");
        })
        .catch(err => {
          if (err?.status === 422 && err?.data?.errors?.files) {
            this.duplicateError = err.data.errors.files;
          } else if (err?.data?.errors?.files) {
            this.error = err.data.errors.files;
          } else if (err?.data?.message) {
            this.error = [err.data.message];
          } else {
            this.error = [this.$t("LABELS.UPLOAD_FAILED")];
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    handleUploadWithMakeUnique() {
      this.handleUpload(true);
    }
  }
};
</script>
